import chaptersSlice from "./common/slice/chaptersSlice";
import ImageUploadSlice from "./common/slice/ImageUploadSlice";
import dataSlice from "./common/slice/dataSlice";
import suggestionSlice from "../component-bundle/suggestion-values/suggestionSlice";
import projectInformationTDD from "./common/report-component/items/project-information/projectInformationTDDSlice";
import textEditorSlice from "./common/report-component/items/text-editors/textEditorSlice";
import contactCardsSlice from "./common/report-component/items/contact-cards/contactCardsSlice";

export const pddStoreReducers = {
    pddChapters: chaptersSlice,
    pddImageUpload : ImageUploadSlice,
    pddDataSlice : dataSlice,
    pddSuggestionSlice:suggestionSlice,
    pddProjectInformation:projectInformationTDD,
    pddTextEditor:textEditorSlice,
    pddContactCardsState:contactCardsSlice,
};

export const pddStoreBlackList = [
    "pddChapters",
    "pddImageUpload",
    "pddDataSlice",
    "pddSuggestionSlice",
    "pddProjectInformation",
    "pddTextEditor",
    "pddContactCardsState",
];
